import React, { useEffect, useRef, useState, useContext, } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "../../../../../stylesheets/components/dowloadHoldingReports/dowloadHoldingReports.scss";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import di from "../../di/servicelocator";
import "bootstrap/dist/css/bootstrap.min.css";
import moment from "moment";
import { emailRegex } from "../../../../../utils/regex";
import { useSelector } from "react-redux";
import { enterMail, validMail } from "@domains/utils/commonText";
import EdButton from "../../../../../components/generic/edbutton/edButton";
import { holdingDownloadDate, previousDay } from "@domains/utils/reportDates";
import { storeEmailListInSessionStorage } from "@domains/utils/sessionMethods";
import EdelRadioButtons from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/EdelRadioButtons";
import { getRadioBtns } from "@frameworks/web/components/Reports/RebrandedReports/constant";
import _ from "underscore";
import { EConsolidated } from "@frameworks/web/components/Reports/constant";
import PANPassword from "@frameworks/web/components/Reports/RebrandedReports/GenericComponents/PANPassword";
import { WebConfigContext } from "@frameworks/web/utils/webConfig";
import { LoginSource } from "@domains/utils/emtReportCallback";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
import { useParams } from "react-router-dom";
const HoldingReportFormDesk = (props) => {
    const webConfig = useContext(WebConfigContext);
    const { loginSource } = useParams();
    const sales_jwt_token = localStorage.getItem("sales_jwt_token");
    const sales_native_app = JSON.parse(localStorage.getItem("sales_native_app"));
    const [startDate, setStartDate] = useState(previousDay);
    const _calendar = useRef(null);
    const showDatePicker = (e) => {
        if (_calendar.current) {
            _calendar.current.setOpen(true);
        }
    };
    const [submitDisabled, setSubmitDisabled] = useState(false);
    const [downloadCheck, setDownloadCheck] = useState(false);
    const [emailCheck, setEmailCheck] = useState(false);
    const [PDF_or_Excel, setPDForExcel] = useState(null);
    const [emailList, setEmailList] = useState([]);
    const sessionEmailList = sessionStorage.getItem("emailList");
    const [currEmailvalue, setCurrEmailValue] = useState();
    const emailStatus = useSelector((state) => state.holdingReport.emailStatus);
    const downloadStatus = useSelector((state) => state.holdingReport.downloadStatus);
    const isImpersonated = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.isImpersonated; });
    const lgnSrc = useSelector((state) => { var _a; return (_a = state === null || state === void 0 ? void 0 : state.accountDetailsReducer) === null || _a === void 0 ? void 0 : _a.lgnSrc; });
    const defaultEmailId = useSelector((state) => state.accountDetailsReducer.emaildId);
    const isClientLogin = loginSource !== LoginSource.SALES &&
        !sales_native_app &&
        !isImpersonated &&
        lgnSrc !== ELoginSource.NESTTRADER;
    const isRMApp = (Boolean(window.self !== window.top) && sales_jwt_token) ||
        sales_native_app;
    const { selectedMember, familyDetails: { myAccCode }, } = useSelector((state) => state.FamilyTagging.familyDetails.reducersData);
    const inputRef = useRef(null);
    const EmailListUpdate = () => {
        if (emailRegex.test(currEmailvalue) &&
            !emailList.includes(currEmailvalue)) {
            setEmailList([...emailList, currEmailvalue]);
            setCurrEmailValue("");
            storeEmailListInSessionStorage(currEmailvalue, sessionEmailList, true);
            return [...emailList, currEmailvalue];
        }
        return [];
    };
    let handleSubmit = (e) => {
        e.preventDefault();
        props.setShowHoldingReport(false);
        props.setShowLoader(true);
        let emailFormat, downloadFormat = undefined;
        if (downloadCheck) {
            downloadFormat = {
                date: moment(startDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
            };
            if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
                downloadFormat.accodes = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
                downloadFormat.isConsolidated =
                    (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.memberName) === EConsolidated.CONSOLIDATED;
            }
            if (webConfig.passwordProtectedDownloadReports)
                downloadFormat.isPwdProtected = true;
            props.setOperation("download");
        }
        if (emailCheck) {
            let list = emailList;
            if (emailList.length === 0 && currEmailvalue.length > 3) {
                list = EmailListUpdate();
            }
            emailFormat = {
                toDate: moment(startDate).format("yyyy-MM-DD"),
                reportType: PDF_or_Excel,
                emailIds: list,
            };
            if (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode) {
                emailFormat.accodes = selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.accCode;
                emailFormat.isConsolidated =
                    (selectedMember === null || selectedMember === void 0 ? void 0 : selectedMember.memberName) === EConsolidated.CONSOLIDATED;
            }
            props.setOperation("email");
        }
        if (downloadCheck && emailCheck) {
            props.setOperation("email_download");
        }
        di.holdingReport.downloadAndSendReport(emailFormat, downloadFormat);
    };
    useEffect(() => {
        if ((emailStatus.isOpen !== null || downloadStatus.isOpen !== null) &&
            props.showLoader &&
            (emailCheck || downloadCheck)) {
            props.setShowLoader(false);
            if ((emailCheck && emailStatus.isOpen === true) ||
                (downloadCheck && downloadStatus.isOpen === true)) {
                props.setDownloadSuccess(true);
            }
            else {
                props.setDownloadFail(true);
            }
        }
    }, [emailStatus.isOpen, downloadStatus.isOpen]);
    useEffect(() => {
        if (defaultEmailId && !emailList.includes(defaultEmailId)) {
            let defaultEmailList = [defaultEmailId];
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = defaultEmailList;
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
        else {
            let sessionEmailArray = sessionEmailList && sessionEmailList.split(",").length > 0
                ? sessionEmailList.split(",")
                : [];
            let finalEmailList = emailList && emailList.length > 0 ? emailList : [];
            if (sessionEmailArray && sessionEmailArray.length > 0) {
                sessionEmailArray.map((emailId) => {
                    if (!emailList.includes(emailId))
                        finalEmailList.push(emailId);
                });
            }
            setEmailList(finalEmailList);
        }
    }, [defaultEmailId, emailCheck]);
    useEffect(() => {
        if (PDF_or_Excel && (emailCheck || downloadCheck)) {
            if (emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && emailCheck && emailList.length > 0) {
                setSubmitDisabled(true);
            }
            else if (downloadCheck && !emailCheck) {
                setSubmitDisabled(true);
            }
            else {
                setSubmitDisabled(false);
            }
        }
        else {
            setSubmitDisabled(false);
        }
    }, [emailCheck, emailList, downloadCheck, PDF_or_Excel]);
    const calendarInputRef = useRef(null);
    const DatePickerButton = React.forwardRef(({ value, onClick }, calendarInputRef) => (React.createElement("a", { 
        // href="#"
        className: "custom-input", onClick: onClick, ref: calendarInputRef }, value)));
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "customForm" },
            React.createElement("div", { className: "header d-flex align-items-center" },
                React.createElement("div", null,
                    React.createElement("i", { className: "edel-icon-timeout-holding" })),
                React.createElement("h2", null, "Generate Report")),
            React.createElement("form", { className: "customFormSection", onSubmit: (e) => handleSubmit(e), onKeyDown: (e) => {
                    if (e.key === "Enter") {
                        if (!currEmailvalue && submitDisabled) {
                            handleSubmit(e);
                        }
                    }
                } },
                React.createElement("div", null,
                    React.createElement("div", { className: "" },
                        React.createElement("div", { className: "customFormSection_field dateWrap" },
                            React.createElement("div", { className: "row" },
                                React.createElement("div", { className: "col-md-12 col-lg-12" },
                                    React.createElement("label", { htmlFor: "date", className: "form-label" }, "Date"),
                                    React.createElement("div", { className: "" },
                                        React.createElement("div", { className: "input-group yearDropdown singleDatePicker holdingReportsDate" },
                                            React.createElement(DatePicker, { selected: startDate, onChange: (date) => setStartDate(date), ref: _calendar, dateFormat: "d-MMM-yy", formatWeekDay: (nameOfDay) => nameOfDay.slice(0, 1), minDate: holdingDownloadDate, maxDate: previousDay, showYearDropdown: true, showMonthDropdown: true, customInput: React.createElement(DatePickerButton, null), scrollableYearDropdown: true }),
                                            React.createElement("a", { className: "input-group-append", onClick: showDatePicker },
                                                React.createElement("span", { className: "input-group-text d-block" },
                                                    React.createElement("i", { className: "edel-icon-calendar-report" }),
                                                    React.createElement("span", null, "Change")))))))),
                        React.createElement("div", { className: "customFormSection_field boder-bottom holdingpdf-summary-details" },
                            React.createElement(EdelRadioButtons, { parentClass: "pdf-excel-midblue-theme", title: "Report Format", selected: PDF_or_Excel, setSelected: (val) => {
                                    if ((isImpersonated || isRMApp) && val === ReportType.EXCEL)
                                        setDownloadCheck(false);
                                    setPDForExcel(val);
                                }, redioBtns: getRadioBtns(ReportName.HOLDINGS) })),
                        React.createElement("div", { className: "customFormSection_field checkboxWrap" },
                            React.createElement("label", { htmlFor: "", className: "form-label" }, "Get Report As"),
                            React.createElement("div", { className: "checkbox" },
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckDefault", checked: downloadCheck, disabled: (isImpersonated || isRMApp) &&
                                            lgnSrc !== "nesttrader" &&
                                            PDF_or_Excel &&
                                            PDF_or_Excel === ReportType.EXCEL, onChange: (e) => {
                                            if ((isImpersonated || isRMApp) &&
                                                PDF_or_Excel === ReportType.EXCEL)
                                                setDownloadCheck(false);
                                            else
                                                setDownloadCheck(e.target.checked);
                                        } }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckDefault" },
                                        React.createElement("span", { className: (isImpersonated || isRMApp) &&
                                                PDF_or_Excel === ReportType.EXCEL
                                                ? "txt_secondary-gray"
                                                : "" }, "Download"))),
                                React.createElement("div", { className: "form-check" },
                                    React.createElement("input", { className: "form-check-input", type: "checkbox", value: "", id: "flexCheckChecked", onChange: (e) => {
                                            setEmailCheck(e.target.checked);
                                        } }),
                                    React.createElement("label", { className: "form-check-label", htmlFor: "flexCheckChecked" }, "Email")))),
                        emailCheck && (React.createElement("div", { className: "customFormSection_field" },
                            React.createElement("div", { className: "blue_bg mail" },
                                emailList.length > 0 && (React.createElement("div", { className: "mail_label" },
                                    React.createElement("ul", { className: "mail_label_body" }, emailList.map((el, idx) => {
                                        return (React.createElement("li", { key: idx, className: "mail_label_body_item" },
                                            el,
                                            React.createElement("span", { className: "mail_label_close", onClick: () => {
                                                    setEmailList((emailList) => emailList.filter((_, i) => emailList[i] !== el));
                                                    storeEmailListInSessionStorage(el, sessionEmailList, false);
                                                } },
                                                React.createElement("i", { className: "edel-icon-rounded-close" }))));
                                    })))),
                                React.createElement("div", { className: "mail-input" },
                                    React.createElement("input", { ref: inputRef, type: "email", className: "form-control", pattern: emailRegex.source, disabled: isImpersonated || lgnSrc === "nesttrader", value: currEmailvalue, onChange: (e) => {
                                            setCurrEmailValue(e.target.value);
                                            e.target.setCustomValidity("");
                                            inputRef.current.checkValidity();
                                        }, placeholder: "Enter email address", required: emailCheck && emailList.length === 0, onInvalid: (e) => {
                                            if (e.currentTarget.validity.valueMissing) {
                                                return e.currentTarget.setCustomValidity(enterMail);
                                            }
                                            if (e.currentTarget.validity.patternMismatch) {
                                                return e.currentTarget.setCustomValidity(validMail);
                                            }
                                        }, onKeyDown: (e) => {
                                            if (e.key === "Enter" &&
                                                !isImpersonated &&
                                                lgnSrc !== "nesttrader") {
                                                e.preventDefault();
                                                EmailListUpdate();
                                                if (inputRef && inputRef.current) {
                                                    inputRef.current.checkValidity();
                                                    inputRef.current.reportValidity();
                                                }
                                            }
                                        } }),
                                    React.createElement("div", { className: `icon ${(isImpersonated || lgnSrc == "nesttrader") &&
                                            "pe-none user-select-auto"}`, onClick: () => {
                                            if (!isImpersonated && lgnSrc !== "nesttrader") {
                                                EmailListUpdate();
                                                if (inputRef && inputRef.current) {
                                                    inputRef.current.checkValidity();
                                                    inputRef.current.reportValidity();
                                                }
                                            }
                                        } },
                                        React.createElement("i", { className: `edel-icon-add ${(isImpersonated || lgnSrc == "nesttrader") &&
                                                "pe-none user-select-auto txt_monochromeGrey"}` }))))))),
                    !isClientLogin && (React.createElement("div", { className: "my-3" },
                        React.createElement(PANPassword, null))),
                    React.createElement("div", null,
                        React.createElement(EdButton, { className: "btn btn-primary custom_btn", type: "submit", disabled: !submitDisabled, value: "Submit", btnTyp: "blue-one" })))))));
};
export default React.memo(HoldingReportFormDesk, (prevProps, nextProps) => _.isEqual(prevProps, nextProps));
